export default __webpack_public_path__ + "static/media/fan_logo.299d6592.svg";